// Shape matches `apollo-cache-inmemory`'s `IntrospectionResultData`, plus the
// `description` field this introspection dump happens to carry (present on
// every entry but never read by either consumer) — kept as-is to avoid
// stripping real data just to fit the library's exact type.
type FragmentTypesIntrospectionData = {
  __schema: {
    types: {
      name: string;
      kind: string;
      possibleTypes: {
        name: string;
        description: string;
      }[];
    }[];
  };
};

const fragmentTypes: FragmentTypesIntrospectionData = {
  __schema: {
    types: [
      {
        name: 'BaseOrderingSettings',
        kind: 'INTERFACE',
        possibleTypes: [
          {
            name: 'InStorePickupOrderingSettings',
            description: '',
          },
          {
            name: 'CurbsidePickupOrderingSettings',
            description: '',
          },
          {
            name: 'DriveThruPickupOrderingSettings',
            description: '',
          },
          {
            name: 'DeliveryOrderingSettings',
            description: '',
          },
        ],
      },
      {
        name: 'PaymentsCheckoutCredentials',
        kind: 'UNION',
        possibleTypes: [
          {
            name: 'ChaseHostedProfileCredentials',
            description: '',
          },
          {
            name: 'MonerisHTProfileCredentials',
            description: '',
          },
        ],
      },
    ],
  },
};

export default fragmentTypes;
